import React from 'react';
import PropTypes from 'prop-types';
import { NO_READ_MESSAGE_TIP_VOICE } from '@/constants';

const NewMessageAudio = (props) => <audio src={NO_READ_MESSAGE_TIP_VOICE} autoPlay={props.autoplay} />;

NewMessageAudio.propTypes = {
  autoplay: PropTypes.bool,
};

export default NewMessageAudio;
